module.exports = __webpack_public_path__ + "static/media/needles@1x.95862ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/misc/src/needles@1x.png
// module id = 558
// module chunks = 0